/**
 * Centred (or overlaid) loading indicator using the F&P primary purple.
 * Ported from `LoadingSpinner.js` to TS.
 */

import React from 'react';
import { Box, CircularProgress } from '@mui/material';

import { UI_CONFIG } from '../../utils/constants';

export type LoadingSpinnerSize = 'small' | 'medium' | 'large';

export interface LoadingSpinnerProps {
  isLoading?: boolean;
  size?: LoadingSpinnerSize;
  color?: string;
  overlay?: boolean;
}

const SIZE_MAP: Record<LoadingSpinnerSize, string> = {
  small: '2rem',
  medium: '5rem',
  large: '8rem',
};

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  isLoading = false,
  size = 'medium',
  color = UI_CONFIG.LOADING_SPINNER_COLOR,
  overlay = false,
}) => {
  if (!isLoading) return null;

  const spinner = (
    <CircularProgress size={SIZE_MAP[size]} thickness={4} style={{ color }} />
  );

  if (overlay) {
    return (
      <Box
        sx={{
          display: 'flex',
          height: '100%',
          position: 'absolute',
          width: '100%',
          top: 0,
          left: 0,
          background: 'rgba(0,0,0,0.5)',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
        }}
      >
        {spinner}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 2,
      }}
    >
      {spinner}
    </Box>
  );
};

export default LoadingSpinner;
